import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

// Modal used to name a new geo fence (or rename the selected one).
@Component({
  selector: 'geo-fence-save-modal',
  templateUrl: './geo-fence-save-modal.component.html',
})
export class GeoFenceSaveModalComponent {
  @Input() nameControl: FormControl;
  @Input() editMode: boolean = false;

  @Output() saved = new EventEmitter<void>();
  @Output() edited = new EventEmitter<void>();
}
